import { Component, Input } from '@angular/core';
import { Order } from '../../../../../overview/models/order';
import { RouterLink } from '@angular/router';
import { DepartureComponent } from '../departure/departure.component';
import { ArrivalComponent } from '../arrival/arrival.component';
import { DetailsSkeletonComponent } from '../details-skeleton/details-skeleton.component';
import { DateTimeFormatPipe } from '../../pipes/date-time-format.pipe';

@Component({
  selector: 'app-details',
  standalone: true,
  templateUrl: './details.component.html',
  imports: [RouterLink, DepartureComponent, ArrivalComponent, DetailsSkeletonComponent, DateTimeFormatPipe],
  styleUrl: './details.component.scss'
})
export class DetailsComponent {
  @Input() order: Order | null = null;
  @Input() isArchived = false;
}
